"use client";

import { useSentryErrorBoundary } from "@/lib/sentry/use-sentry-error-boundary";
import { ErrorContent } from "@/components/error-content";

export default function RootError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useSentryErrorBoundary(error);

  return (
    <ErrorContent
      layout="fullscreen"
      heading="Something went wrong"
      description="An unexpected error occurred. Please try again."
      error={error}
      reset={reset}
    />
  );
}
